module.exports = __webpack_public_path__ + "static/media/more.29c08fd1.svg";